import { Button } from "@/components/ui/button";
import { Upload, Camera, ArrowLeft } from "lucide-react";

export function UploadStep({
  onBack,
  dragOver,
  setDragOver,
  onDrop,
  fileRef,
  cameraRef,
  handleFiles,
}) {
  return (
    <div className="max-w-3xl mx-auto" data-testid="upload-screen">
      <button
        onClick={onBack}
        className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1.5 mb-6 transition-colors"
        data-testid="back-button"
      >
        <ArrowLeft className="h-4 w-4" /> Zurück zur Übersicht
      </button>

      <div className="mb-6">
        <h1 className="font-heading text-4xl tracking-tight font-medium">Beleg scannen</h1>
        <p className="text-muted-foreground mt-1">
          Laden Sie ein Bild des Zahlungsbelegs hoch oder erstellen Sie ein Neues – die BeSca
          Value-Engine liest die entsprechenden Parameter automatisch aus. Sie können diese in einem
          weiteren Schritt noch überprüfen.
        </p>
      </div>

      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={onDrop}
        onClick={() => fileRef.current?.click()}
        data-testid="upload-dropzone"
        className={`grid-bg cursor-pointer border-2 border-dashed rounded-md py-8 md:py-20 px-6 flex flex-col items-center justify-center text-center transition-colors duration-150 ${
          dragOver
            ? "border-primary bg-primary/5"
            : "border-border hover:border-primary/60 bg-card"
        }`}
      >
        <div className="hidden md:flex h-16 w-16 rounded-sm bg-primary/10 items-center justify-center mb-5">
          <Upload className="h-8 w-8 text-primary" />
        </div>
        <h3 className="hidden md:block font-heading text-xl font-medium">Datei hierher ziehen</h3>
        <p className="hidden md:block text-muted-foreground text-sm mt-1 mb-6">
          oder wählen Sie eine Quelle (JPG, PNG, HEIC, PDF)
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center w-full">
          <Button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              fileRef.current?.click();
            }}
            className="gap-2 w-full sm:w-auto"
            data-testid="upload-file-button"
          >
            <Upload className="h-4 w-4" /> Datei auswählen
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation();
              cameraRef.current?.click();
            }}
            className="gap-2 border border-border md:hidden w-full sm:w-auto"
            data-testid="open-camera-button"
          >
            <Camera className="h-4 w-4" /> Kamera öffnen
          </Button>
        </div>
      </div>

      <input
        ref={fileRef}
        type="file"
        accept="image/*,.heic,.heif,application/pdf,.pdf"
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
        data-testid="file-input"
      />
      <input
        ref={cameraRef}
        type="file"
        accept="image/*,.heic,.heif"
        capture="environment"
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
        data-testid="camera-input"
      />
    </div>
  );
}
